import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getApiScopes } from "./apiScopes";

/**
 * Returns an access token for the Nature4D API (Bearer), or null if redirect was started.
 */
export async function acquireApiAccessToken(instance, account) {
  const scopes = getApiScopes();
  if (!scopes.length) {
    throw new Error(
      "Set REACT_APP_ENTRA_API_SCOPE or REACT_APP_ENTRA_AUDIENCE (same family as backend ENTRA_AUDIENCE)."
    );
  }

  try {
    const result = await instance.acquireTokenSilent({
      scopes,
      account,
    });
    return result.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      await instance.acquireTokenRedirect({
        scopes,
        account,
      });
      return null;
    }
    throw err;
  }
}
